import { Text } from '@genial/components';
import { Box } from 'native-base';
import React from 'react';

export const EmptyDetails: React.FC = () => (
  <Box py="stack.xxxs">
    <Text variant="regular" fontSize="md" color="neutral.dark">
      Nenhuma compra encontrada para este título.
    </Text>
  </Box>
);
